import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const primaryMenuItems = accountId => [
  {
    icon: 'mail-inbox',
    key: 'inboxView',
    label: 'INBOX_VIEW',
    featureFlag: FEATURE_FLAGS.INBOX_VIEW,
    toState: frontendURL(`accounts/${accountId}/inbox-view`),
    toStateName: 'inbox_view',
    roles: ['administrator', 'agent', 'supervisor', 'master', 'operator'],
  },
  {
    icon: 'chat',
    key: 'conversations',
    label: 'CONVERSATIONS',
    toState: frontendURL(`accounts/${accountId}/dashboard`),
    toStateName: 'home',
    roles: ['administrator', 'agent', 'supervisor', 'master', 'operator'],
  },
  {
    icon: 'book-contacts',
    key: 'contacts',
    label: 'CONTACTS',
    featureFlag: FEATURE_FLAGS.CRM,
    toState: frontendURL(`accounts/${accountId}/contacts`),
    toStateName: 'contacts_dashboard',
    roles: ['administrator', 'agent', 'supervisor', 'master', 'operator'],
  },
  {
    icon: 'arrow-trending-lines',
    key: 'reports',
    label: 'REPORTS',
    featureFlag: FEATURE_FLAGS.REPORTS,
    toState: frontendURL(`accounts/${accountId}/reports`),
    toStateName: 'settings_account_reports',
    roles: ['administrator', 'supervisor', 'master'],
  },
  {
    icon: 'building-bank',
    key: 'finops',
    label: 'FINOPS',
    toState: frontendURL(`accounts/${accountId}/finops/dashboard`),
    toStateName: 'finops_dashboard',
    roles: ['administrator', 'master'],
  },
  {
    icon: 'megaphone',
    key: 'campaigns',
    label: 'CAMPAIGNS',
    featureFlag: FEATURE_FLAGS.CAMPAIGNS,
    featureFlagForAgents: FEATURE_FLAGS.AGENTS_CAMPAIGNS,
    toState: frontendURL(`accounts/${accountId}/campaigns`),
    toStateName: 'ongoing_campaigns',
    roles: ['administrator', 'master'],
    agentRoles: ['agent', 'supervisor'],
  },
  {
    icon: 'library',
    key: 'helpcenter',
    label: 'HELP_CENTER.TITLE',
    featureFlag: FEATURE_FLAGS.HELP_CENTER,
    alwaysVisibleOnChatwootInstances: true,
    toState: frontendURL(`accounts/${accountId}/portals`),
    toStateName: 'default_portal_articles',
    roles: ['administrator', 'supervisor', 'master'],
  },
  {
    icon: 'data-trending',
    key: 'queuemetrics',
    label: 'QUEUE_METRICS',
    featureFlag: FEATURE_FLAGS.QUEUE_METRICS,
    toState: frontendURL(`accounts/${accountId}/queuemetrics`),
    toStateName: 'queue_metrics',
    roles: ['administrator', 'agent', 'supervisor', 'master'],
  },
  {
    icon: 'headset-add',
    key: 'support',
    label: 'SUPPORT_PANEL',
    toState: frontendURL(`accounts/${accountId}/support`),
    toStateName: 'support_diagnostics',
    roles: ['administrator', 'supervisor', 'master'],
  },
  {
    icon: 'settings',
    key: 'settings',
    label: 'SETTINGS',
    toState: frontendURL(`accounts/${accountId}/settings`),
    toStateName: 'settings_home',
    roles: ['administrator', 'agent', 'supervisor', 'master', 'operator'],
  },
];

export default primaryMenuItems;
